export default {
    section: 'Contact Information',
    name: 'employee-owner-contact-information',
    questionWidth: 4,
    items: [
        {
            type: 'inline',
            text: 'Contact Name',
            items: [
                {
                    type: 'text-field',
                    name: 'employee-owner-first-name',
                    width: 3,
                    props: {
                        label: 'First Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'employee-owner-last-name',
                    width: 3,
                    props: {
                        label: 'Last Name'
                    }
                }
            ]
        },
        {
            type: 'text-field',
            text: 'Contact Email',
            name: 'employee-owner-email',
            props: {
                label: 'Email'
            }
        },
        {
            type: 'text-field',
            text: 'Contact Phone Number',
            name: 'employee-owner-phone',
            width: 3,
            props: {
                label: 'Phone',
                format: 'phone'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/employee-owner/valuation-data/contact-information.js